import React, { ReactElement, useEffect, useState } from 'react';
import ReactTelInput from 'react-telephone-input';
import { Global } from '@emotion/react';

import { TelInputStyle } from './TelInputCss';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const flagImages = require('./flags.png');

const normalizeOutputValue = (value: string) => (value === '+' ? '' : value);
const normalizeInputValue = (value: string) => (value === '' ? '+' : value);

interface Props {
    value: string;
    default?: string;
    defaultCountry?: string;
    onChange: (value: string) => void;
    [key: string]: any;
}

const TelInput = ({
    value,
    default: defaultValue,
    defaultCountry,
    onChange,
    ...props
}: Props): ReactElement => {
    const [internalValue, setInternalValue] = useState(
        normalizeInputValue(value || defaultValue || '')
    );

    const handleInternalChange = (nextValue: string) => {
        if (nextValue === internalValue) return;
        setInternalValue(nextValue);
        onChange(normalizeOutputValue(nextValue));
    };

    const handleExternalChange = () => {
        const normalizedValue = normalizeInputValue(value);

        if (normalizedValue !== internalValue) setInternalValue(normalizedValue);
    };

    useEffect(handleExternalChange, [value]);

    return (
        <>
            <Global styles={TelInputStyle} />
            <ReactTelInput
                classNames={TelInputStyle}
                defaultCountry={defaultCountry?.toLowerCase() || 'us'}
                listStyle={{ zIndex: 2000, position: 'absolute', maxHeight: 200 }}
                flagsImagePath={flagImages}
                {...props}
                value={internalValue}
                onChange={handleInternalChange}
            />
        </>
    );
};

export default TelInput;
